<ng-container #bannerContainer></ng-container>

<div class="relative flex flex-col h-full bg-white">
  <mat-drawer-container [hasBackdrop]="true">
    <mat-drawer-content>
      <div class="flex flex-row overflow-auto" [ngStyle]="{'height': 'calc(100vh - ' + bannersHeight + 'px)'}">
        <!-- Sidenav -->
        <flow-sidenav *ngIf="!appService.navHidden"></flow-sidenav>

        <!-- Main Content -->
        <div class="flex flex-col flex-1 px-8 pt-6 mb-6 overflow-y-auto scrollable-parent-div">
          <div
            #top
            [ngClass]="{
              'has-toolbar-form-actions': appService.hasToolbarFormActions,
              'h-[100%] flex-1': !appService.navHidden
            }">
            <router-outlet></router-outlet>

            <div class="fixed bottom-10 right-10 z-50">
              <flow-button *ngIf="showNavigateToTopBtn" variant="primary" (onClick)="scrollToTop()">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                </svg>
              </flow-button>
            </div>
          </div>
        </div>
      </div>
    </mat-drawer-content>

    <!-- Side Panel -->
    <mat-drawer #sidePanel mode="over" position="end">
      <flow-side-panel class="h-full overflow-hidden" [sidePanel]="sidePanel"></flow-side-panel>
    </mat-drawer>
  </mat-drawer-container>
</div>
